/*
 * Generic species link
 */
 a.species {
  /* override the <a> underline */
  text-decoration: none;
  color: blue;
  display: flex;
  flex-direction: column;

  .common {
    font-size: 14px;
    font-weight: 500;
  }

  .scientific {
    /* cursor: pointer; */
    /* override the <a> defaults */
    color: gray;
    text-decoration: none;
    font-size: 11px;
  }
}
